<template>
    <common-modal v-if="isOpen" class="delete-modal" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <common-page-header
                :heading="$t('modals.delete_patient.title')"
                :content="$t('modals.delete_patient.content')"
                :isCenter="true"
                contentSpacing="medium"
                contentColor="secondary"
            ></common-page-header>
            <common-content-wrapper width="large">
                <delete-form @cancel="emitEvent({ name: 'close' })"></delete-form>
            </common-content-wrapper>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import DeleteForm from 'components/forms/patient/DeleteForm'
    export default {
        components: { DeleteForm },

        props: {
            isOpen: { type: Boolean, required: true },
        },
    }
</script>
